import React from 'react';
import { ReactComponent as BizIcon } from 'assets/svg/biz-loading.svg';

const Loading: React.FC = (): JSX.Element => {
    return (
        <div className="mx-auto mt-5" style={{ textAlign: 'center' }}>
            <BizIcon />
        </div>
    );
};

export default Loading;
